import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import { clearAuthError, signIn } from "../../redux/slices/authSlice";
import "./styles.css";

export default function Login({ variant = "legacy", dashboardPath = "/IaDashboard" }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, accessToken, error } = useSelector((s) => s.auth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [didSubmit, setDidSubmit] = useState(false);

  const isAuthenticated = user && accessToken;

  useEffect(() => {
    dispatch(clearAuthError());
    setDidSubmit(false);
  }, [email, password, dispatch]);

  useEffect(() => {
    if (didSubmit && user && !error) {
      navigate(dashboardPath, { replace: true });
    }
  }, [didSubmit, user, error, navigate, dashboardPath]);

  if (isAuthenticated) {
    return <Navigate to={dashboardPath} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setDidSubmit(true);
    try {
      const resp = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: email, password }),
      });

      const data = await resp.json();

      if (resp.ok && data.success) {
        dispatch(
          signIn({
            user: { email: email, username: email },
            accessToken: data.accessToken || "ACCESS_TOKEN",
            refreshToken: data.refreshToken || "REFRESH_TOKEN",
          })
        );
        navigate(dashboardPath, { replace: true });
      } else {
        alert(data.error || "Credenciales incorrectas");
        setDidSubmit(false);
      }
    } catch (err) {
      console.error("Error login:", err);
      setDidSubmit(false);
    }
  };

  return (
    <div className="login__wrap login__wrap--gradient">
      <div className="login__panel">
        <h1 className="login__brand">{variant === "sharma" ? "RYSE·" : "RYSE"}</h1>

        <form className="login__form" onSubmit={onSubmit}>
          <label className="login__label">
            <span>Email</span>
            <input
              type="email"
              className="login__input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
            />
          </label>

          <label className="login__label">
            <span>Password</span>
            <input
              type="password"
              className="login__input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>

          {error && (
            <span className="login__error" role="alert" aria-live="assertive">
              {error}
            </span>
          )}

          <button type="submit" className="login__button">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
